import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("pool_token");
    if (!token) {
      setUser(false);
      setReady(true);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => {
        localStorage.removeItem("pool_token");
        setUser(false);
      })
      .finally(() => setReady(true));
  }, []);

  const finishAuth = (data) => {
    localStorage.setItem("pool_token", data.token);
    setUser(data.user);
  };

  const login = async (username, password) => {
    const res = await api.post("/auth/login", { username, password });
    finishAuth(res.data);
  };

  const register = async (username, password) => {
    const res = await api.post("/auth/register", { username, password });
    finishAuth(res.data);
  };

  const logout = () => {
    localStorage.removeItem("pool_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
